import React from "react";
import { motion } from "framer-motion";

const pillars = [
  {
    id: "recuperar",
    num: "R₁",
    icon: "/assets/iconitos_03.png",
    title: "RECUPERAR",
    body: "Identificamos materiales valorizables dentro de la corriente de descartes para reintroducirlos al ciclo productivo.",
  },
  {
    id: "reusar",
    num: "R₂",
    icon: "/assets/iconitos_06.png",
    title: "REUSAR",
    body: "Promovemos el uso prolongado y la revalorización de activos antes de su disposición final.",
  },
  {
    id: "reciclar",
    num: "R₃",
    icon: "/assets/iconitos_11.png",
    title: "RECICLAR",
    body: "Procesamos materiales a través de plantas habilitadas que cumplen con la normativa ambiental vigente.",
  },
  {
    id: "reducir",
    num: "R₄",
    icon: "/assets/iconitos_14.png",
    title: "REDUCIR",
    body: "Asesoramos en origen para disminuir la generación de residuos y los costos operativos asociados.",
  },
];

export default function Philosophy() {
  return (
    <section
      id="filosofia"
      data-testid="philosophy-section"
      className="bg-forest-900 text-bone relative overflow-hidden py-24 md:py-32"
    >
      <div className="absolute inset-0 grain-heavy pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 accent-line" />

      <div className="max-w-[1500px] mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <div className="tag text-lime-400 mb-5 lime-rule">
              Filosofía operativa
            </div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[80px] leading-[0.92]">
              Modelo
              <br />
              <span className="text-lime-400">de las 4R.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-bone/75 text-lg max-w-md self-end">
            Un compromiso operativo que guía cada decisión: desde el diseño
            del circuito de recolección hasta la elección del destino final
            de cada residuo.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-bone/15">
          {pillars.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`philosophy-${p.id}`}
              className={`group relative p-8 lg:p-10 hover:bg-forest-800 transition-colors ${
                i < 3 ? "lg:border-r" : ""
              } ${i < 2 ? "sm:border-r" : ""} ${
                i >= 2 ? "border-t sm:border-t-0 lg:border-t-0" : ""
              } ${i === 1 ? "border-t sm:border-t-0" : ""} ${
                i === 3 ? "border-t lg:border-t-0" : ""
              } border-bone/15`}
            >
              <div className="flex items-baseline justify-between mb-7">
                <span className="font-mono text-lime-400 text-lg">{p.num}</span>
                <span className="tag text-bone/40">
                  0{i + 1}/04
                </span>
              </div>
              <img
                src={p.icon}
                alt=""
                aria-hidden="true"
                className="w-16 h-16 object-contain mb-7 group-hover:scale-110 transition-transform"
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <h3 className="font-display text-4xl mb-4 group-hover:text-lime-400 transition-colors">
                {p.title}
              </h3>
              <p className="text-sm text-bone/70 leading-relaxed">
                {p.body}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 max-w-4xl border-l-4 border-lime-400 pl-8">
          <div className="tag text-lime-400 mb-3">Nuestro compromiso</div>
          <p className="font-display text-3xl md:text-5xl leading-[0.95] text-bone">
            "Garantizar que el destino de sus residuos sea
            <span className="text-lime-400"> el correcto</span>,
            satisfaciendo sus necesidades operativas mientras cuidamos
            juntos el medio ambiente."
          </p>
        </div>
      </div>
    </section>
  );
}
